<template>
  <span v-if="icon" class="w-full flex justify-center" v-html="icon" :class="computedClass" />
</template>

<script setup lang="ts">
const props = defineProps<{
  name?: string;
  color?: string;
  classes?: string;
}>();

// Auto-load icons
const icons = Object.fromEntries(
  Object.entries(
    import.meta.glob("../../../public/svg/*.svg", { 
      query: '?raw',
      import: 'default'
    })
  ).map(([key, value]) => {
    const filename = key.split("/").pop()!.split(".").shift();
    return [filename, value];
  })
);

const computedClass = computed(() => {
  return `${props.classes ? props.classes : ""} ${
    props.color ? props.color : "text-blue-500"
  }`;
});

// Lazily load the icon
const icon = props.name && (await icons?.[props.name]?.());
</script>
